import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getFindSatisfactionSurveyKey = (
  orderId: string,
  customerId?: string,
): UseDataQuery['queryKey'] => ['satisfaction-survey', orderId, customerId ?? 'no-customer'];
